import React, { useEffect } from 'react';
import {
  makeStyles,
  DialogContent,
} from "@material-ui/core";

import { useSelector } from 'react-redux';
import { DialogResponsive } from './DialogResponsive';
import { ImagineGrid as Grid } from '../../components';
import { useDispatch } from "react-redux";
import { infraStructureActions } from './../../actions';
import { TagInfrastructure } from "./../Infrastructure"
import { DialogCustomTitle } from '../CreateIdeaDialogs';
import { useTranslation } from 'react-i18next';


const useStyle = makeStyles((theme) => ({
  content: {

    maxHeight: '600px',
  },
  modalWrapper: {
    padding: "2rem",
    justifySelf: "center"
  },
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  warningIcon: {
    color: "#FE9900",
    fontSize: 100,
  },
  button: {
    width: "100%"
  },
  playButton: {
    border: '0'
  },
  titleWrapper: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: '1px solid #e9e9e9',
  },
  title: {
    fontWeight: 600,
    font: 'normal normal 600 20px/30px Poppins',
  },
  description: {
    textAlign: "left",
    fontSize: 16
  },
  item: {
    borderBottom: '1px solid #e9e9e9',
  },
  itemCell: {
    padding: '24px 24px 24px 0',
  },
  itemColumn: {
    padding: '24px 0 0 0',
  }
}))

export const DialogInfraDetails = ({ open, id, type, typeDialog, handleCloseAssociationInfra, name, date }) => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const {
    infraDetails
  } = useSelector((state) => state.infraStructure);


  function handleCloseButton() {
    handleCloseAssociationInfra()
  }

  useEffect(() => {
    const infra = {
      id,
      type: type,
      name: name,
      date,
    }
    if (infra.id) {
      dispatch(infraStructureActions.getDetails({ infra }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, type, name])

  return (
    <DialogResponsive
      open={open}
      onClose={handleCloseButton}
    >
      <DialogCustomTitle
        id="scroll-dialog-title"
        onClose={handleCloseButton}
      >
        {t('detalhes_da_infraestrutura')}
      </DialogCustomTitle>
      <DialogContent
        className={classes.content}
        dividers={true}
      >
        <Grid
          item
        >
          <Grid
            container
            spacing={5}
            cols={3}
          >
            <Grid item>
              <b>{t('dados')}</b>
            </Grid>
            <Grid item>
            </Grid>
            <Grid item  >
            </Grid>
          </Grid>
          <Grid container spacing={5} cols={3}>
            <Grid
              item
              className={classes.itemColumn}
            >
              <TagInfrastructure
                type={type} />
            </Grid>
            <Grid item>
            </Grid>
            <Grid item  >
            </Grid>
          </Grid>
          <Grid
            container
            spacing={5}
            cols={3}
            className={classes.itemColumn}
          >
            <Grid item>
              <b>{t('data_de_cadastro')}</b>
              <Grid item>
                {date}
              </Grid>
            </Grid>
            <Grid item>
              <b>{t('nome_da_infraestrutura')}</b>
              <Grid item>
                {name}
              </Grid>
            </Grid>
            <Grid item  >
            </Grid>
          </Grid>
          {
            !infraDetails.loading ? infraDetails.details.associations?.length > 0 ? (
              <>
                <Grid container spacing={5} cols={3}>
                  <Grid
                    item
                    className={classes.itemColumn}
                  >
                    <b>{t('vinculos')}</b>
                  </Grid>
                  <Grid item>
                  </Grid>
                  <Grid item  >
                  </Grid>
                </Grid>
                <Grid container spacing={5} cols={3}>
                  <Grid
                    item
                    className={classes.itemColumn}
                  >
                    <b>{t('unidade_de_negocio')}</b>
                  </Grid>
                  <Grid
                    item
                    className={classes.itemColumn}
                  >
                    <b>{t('local')}</b>

                  </Grid>
                  <Grid
                    item
                    className={classes.itemColumn}
                  >
                    <b>{t('area_de_atuacao')}</b>
                  </Grid>
                </Grid>


                {
                  infraDetails.details.associations?.map((item) => {
                    return (
                      <Grid
                        container
                        spacing={5}
                        cols={3}
                        className={classes.item}
                        key={item.id}
                      >
                        <Grid
                          className={classes.itemCell}
                          item
                        >
                          {item.businessUnit.name}
                        </Grid>
                        <Grid
                          item
                          className={classes.itemCell}
                        >
                          {item.local.name}
                        </Grid>
                        <Grid
                          item
                          className={classes.itemCell}
                        >
                          {item.occupationArea.name}
                        </Grid>
                      </Grid>
                    )
                  }
                  )
                }
              </>
            ) : (<></>) : (<></>)
          }


        </Grid>

      </DialogContent>




    </DialogResponsive >
  )
}
